import { GIT_PROVIDERS } from './constants';
import GithubLogo from 'images/logos/github-logo.svg';
import GitlabLogo from 'images/logos/gitlab-logo.svg';
import BitbucketLogo from 'images/logos/bitbucket-logo.svg';
import AzureDevopsLogo from 'images/logos/azure-devops.svg';

/**
 * GitTypes - types of available git services
 */
const GitTypes = {
  GITHUB: 'github',
  GITLAB: 'gitlab',
  BITBUCKET: 'bitbucket',
  AZURE_DEVOPS: 'azure_devops'
};

export const MAP_GIT_PROVIDERS = {
  [GIT_PROVIDERS.GITHUB]: {
    name: 'Github',
    logo: GithubLogo
  },
  [GIT_PROVIDERS.GITLAB]: {
    name: 'Gitlab',
    logo: GitlabLogo
  },
  [GIT_PROVIDERS.BITBUCKET]: {
    name: 'Bitbucket',
    logo: BitbucketLogo
  },
  [GIT_PROVIDERS.BITBUCKET_SERVER]: {
    name: 'Bitbucket Server',
    logo: BitbucketLogo
  },
  [GIT_PROVIDERS.AZURE_DEVOPS]: {
    name: 'Azure DevOps',
    logo: AzureDevopsLogo
  }
};

export default GitTypes;
